const BLOCKED_KEYS = ['.', ',']
const SEPARATOR_TEST_REGEX = /[.,]/
const SEPARATOR_REPLACE_REGEX = /[.,]/g

export default function blockAmountSeparatorKeydown (event) {
  if (BLOCKED_KEYS.includes(event.key)) {
    event.preventDefault()
  }
}

export function blockAmountSeparatorPaste (event) {
  const clipboardData = event.clipboardData || window.clipboardData
  const pastedText = clipboardData.getData('text')

  if (!SEPARATOR_TEST_REGEX.test(pastedText)) {
    return
  }

  event.preventDefault()
  document.execCommand('insertText', false, pastedText.replace(SEPARATOR_REPLACE_REGEX, ''))
}

// Variants for money inputs that accept cents: only the thousands separator is blocked,
// the decimal point stays allowed.
const BLOCKED_THOUSANDS_KEYS = [',']
const THOUSANDS_TEST_REGEX = /,/
const THOUSANDS_REPLACE_REGEX = /,/g

export function blockThousandsSeparatorKeydown (event) {
  if (BLOCKED_THOUSANDS_KEYS.includes(event.key)) {
    event.preventDefault()
  }
}

export function blockThousandsSeparatorPaste (event) {
  const clipboardData = event.clipboardData || window.clipboardData
  const pastedText = clipboardData.getData('text')

  if (!THOUSANDS_TEST_REGEX.test(pastedText)) {
    return
  }

  event.preventDefault()
  document.execCommand('insertText', false, pastedText.replace(THOUSANDS_REPLACE_REGEX, ''))
}
